import React from 'react';

export const LikeOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7 2C12.5962 2 11.5791 2.59845 11.0431 3.56338L10.6178 4.3289C9.68655 6.00509 8.4726 7.50771 7.02954 8.77038L6.74399 9.02024C6.40115 8.4113 5.74861 8 5 8H3C1.89543 8 1 8.89543 1 10V20C1 21.1046 1.89543 22 3 22H5C5.90435 22 6.66851 21.3998 6.91583 20.5759L7.86362 21.0498C9.11332 21.6747 10.4913 22 11.8885 22H16.117C18.2691 22 20.1798 20.6228 20.8604 18.5811L23.0712 11.9487C23.7187 10.0061 22.2728 8 20.2251 8H15.618L16.4186 6.39879C17.4291 4.37783 15.9595 2 13.7 2ZM7 17.7639C7 18.1427 7.214 18.489 7.55279 18.6584L8.75805 19.261C9.73004 19.747 10.8018 20 11.8885 20H16.117C17.4083 20 18.5547 19.1737 18.963 17.9487L21.1738 11.3162C21.3897 10.6687 20.9077 10 20.2251 10H14.7454C13.6595 10 12.9533 8.85731 13.4389 7.88612L14.6298 5.50436C14.9754 4.8132 14.4728 4 13.7 4C13.3225 4 12.9747 4.20467 12.7914 4.53467L12.3661 5.30018C11.3229 7.17786 9.96307 8.86108 8.34655 10.2755L7.11953 11.3492C7.04357 11.4156 7 11.5117 7 11.6126V17.7639ZM5 11.6126V10H3V20H5V17.7639V11.6126Z"
      fill="currentColor"
    />
  </svg>
);
